module.exports = "/_next/static/images/2e2a07fb4d1f3c83c971d836e8a6dfa1-lock.svg.webp";